import * as React from 'react';

import styles from './Form.scss';

export interface FormProps {
  thanksText: string;
}

const ThankYou: React.SFC<FormProps> = ({ thanksText }) => (
  <div className={styles.thankYou}>
    <span className={styles.thankYouContent} dangerouslySetInnerHTML={{ __html: thanksText }} />
  </div>
);

export default ThankYou;



// WEBPACK FOOTER //
// /www/client/src/components/Form/ThankYou.tsx